module.exports = __webpack_public_path__ + "static/media/user-flow-general.308b6693.svg";